package com.milta.feature.subscription.domain.usecase

import com.milta.feature.subscription.domain.entity.SubscriptionAccessCheck
import com.milta.feature.subscription.domain.repository.SubscriptionAccessRepository

class CheckSubscriptionAccessUseCase(private val repository: SubscriptionAccessRepository) {
    suspend operator fun invoke(): SubscriptionAccessCheck = repository.checkAccess()
}
